import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useCallback } from "react";
import RouteName from "../../../../routes/Route.name";
import history from "../../../../libs/history.utils";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import { actionFetchSideEffects, actionSetPageSideEffects } from "../../../../actions/ReportedSideEffects.action";
import { serviceGetList } from "../../../../services/index.services";

const useReportedSideEffectsHook = () => {
    const { id: userId } = useParams();
    const [editData, setEditData] = useState(null);
    const [isSidePanel, setSidePanel] = useState(false);
    const [listData, setListData] = useState([]);

    const dispatch = useDispatch();
    const {
        sorting_data: sortingData,
        is_fetching: isFetching,
        query,
        query_data: queryData,
        all,
      
    } = useSelector((state) => state?.side_effects);

    const isMountRef = useRef(false);

    useEffect(() => {
        dispatch(
            actionFetchSideEffects(1, {}, {
                query: isMountRef.current ? query : null,
                query_data: isMountRef.current ? queryData : null,
                userId: userId,
            }
            )
        );
        isMountRef.current = true;
    }, [userId, dispatch, query, queryData]);
    
    useEffect(() => {
        serviceGetList([
          "CLIENTS", "PROGRAMS"
        ]).then((res) => {
          if (!res.error) {
            setListData(res.data);
          }
        });
      }, []);

    const handlePageChange = useCallback((type) => {
        dispatch(actionSetPageSideEffects(type));
    }, [dispatch]);

    const queryFilter = useCallback(
        (key, value) => {
            dispatch(
                actionFetchSideEffects(1, sortingData, {
                    query: key === "SEARCH_TEXT" ? value : query,
                    query_data: key === "FILTER_DATA" ? value : queryData,               
                    userId: userId
                })
            );
        },
        [sortingData, query, queryData]
    );

    const handleSearchValueChange = useCallback(
        (value) => {
            queryFilter("SEARCH_TEXT", value);
        },
        [queryFilter]
    );

    const handleSortOrderChange = useCallback(
        (row, order) => {
            dispatch(actionFetchSideEffects(1));
            dispatch(
                actionFetchSideEffects(1,
                    { row, order }, {
                    query: query,
                    query_data: queryData,
                    userId: userId
                }
                )
            );
        },
        [userId, dispatch, query, queryData]
    );

    const handleFilterDataChange = useCallback(
        (value) => {
            queryFilter("FILTER_DATA", value);
        },
        [queryFilter]
    );

    const handleDetail = useCallback((type) => {
        history.push(`${RouteName.REPORTED_DETAIL}${type?.id}`);
    }, []);


 

    const handleSideToggle = useCallback(
        (data) => {
          setSidePanel((e) => !e);
          if (data) {
            setEditData(data?.id);
          } else {
            setEditData(null);
          }
        },
        [setEditData, setSidePanel]
      );

      const configFilter = useMemo(() => {
        return [
          {
            label: "Client",
            name: "client_id",
            type: "selectObject",
            custom: { extract: { id: "id", title: "name" } },
            fields: listData?.CLIENTS,
          },
          {
            label: "Program",
            name: "program_id",
            type: "selectObject",
            custom: { extract: { id: "id", title: "name" } },
            fields:  listData?.PROGRAMS,
          },
        ];
      }, [listData]);

    return {
        configFilter,
        isFetching,
        handleDetail,
        handleSearchValueChange,
        handleFilterDataChange,
        handleSortOrderChange,
        handlePageChange,
        handleSideToggle,
        isSidePanel,
        editData
    }
}

export default useReportedSideEffectsHook